import { defineMessages } from 'react-intl';

export default defineMessages({
  combineModalHeader: {
    description: 'Combine Modal Header',
    defaultMessage: 'Combine Products ({selectedCount} Selected)',
    id: 'eNEYp0',
  },
  combineModalExplanation: {
    description: 'Combine Modal Explanation',
    defaultMessage:
      'Combining products is a process which allows you to clean up and organize your product catalog. You can consolidate multiple products into one, or tie together several similar products for better reporting and easier management.',
    id: 'QJbEzS',
  },
  combineModalQuestion: {
    description: 'Combine Modal Question',
    defaultMessage: 'How would you like to combine the products in the following step?',
    id: 'doBI8U',
  },
  combineModalVariantLabelTitle: {
    description: 'Combine Modal Variant Label Title',
    defaultMessage: 'These products are variations of the same product, for example, different size and color combinations.',
    id: 'm/qS49',
  },
  combineModalVariantLabelSubtitle: {
    description: 'Combine Modal Variant Label Subtitle',
    defaultMessage: 'Combining these products will create a Parent product with the selected products as its Variants.',
    id: 'lia0VX',
  },
  combineModalAliasLabelTitle: {
    description: 'Combine Modal Alias Label Title',
    defaultMessage: 'These products are identical, but are sold under different SKUs.',
    id: '54yT4O',
  },
  combineModalAliasLabelSubtitle: {
    description: 'Combine Modal Alias Label Subtitle',
    defaultMessage: 'Combining these products will create Aliases under the surviving product.',
    id: '/eUhMD',
  },
  combineModalVariantsAbout: {
    description: 'Combine Variants About Blurb',
    defaultMessage:
      'Provide a SKU and Name for the new Parent product of the Variants listed below. Variants inherit properties from their Parent, unless overridden.',
    id: '4pQL8t',
  },
  combineModalAliasAbout: {
    description: 'Combine Alias About Blurb',
    defaultMessage:
      'The first product listed will be the surviving product, you can drag and drop to reorder this list. Existing orders will be updated to reference the surviving product.',
    id: 'PwcnfM',
  },
  combineConfirmModalHeader: {
    description: 'Combine Modal Confirm Title',
    defaultMessage: 'Are you sure?',
    id: 'GsE191',
  },
  combineVariantConfirmDescription: {
    description: 'Combine Variant Modal Body Message',
    defaultMessage:
      "The selected products will be added as Variants of newly created Parent product. You'll be able to: Set up presets for all Variants through the new Parent product View reports according to the Parent product Are you sure you want to combine these { selectedProductCount } products?",
    id: 'FtrP62',
  },
  combineAliasConfirmDescription: {
    description: 'Combine Alias Modal Body Message',
    defaultMessage:
      'All non-surviving products will be deactivated and added as an alias SKU on the single surviving product. New order items will begin to reference the surviving product, but existing history will not be updated. Are you sure you want to combine these { selectedProductCount } products?',
    id: 'PXQ/qc',
  },
  becomeSurvivingProduct: {
    description: 'Combine Alias Survivor Droppable Item Message',
    defaultMessage: 'This will be the surviving product.',
    id: 'Pk1Y87',
  },
  becomeAliasProduct: {
    description: 'Combine Alias Droppable Item Message',
    defaultMessage: 'This SKU will become an alias.',
    id: 'Iguuct',
  },
  close: {
    defaultMessage: 'Close',
    id: 'T8XEzQ',
    description: 'Close Modal',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'AxxlWW',
    description: 'Cancel and Close Modal',
  },
  confirm: {
    defaultMessage: 'Confirm',
    id: 'EVTwSH',
    description: 'Confirm Button on Modal',
  },
  productImportModalTitle: {
    defaultMessage: 'Product Import',
    id: 'wsoZHL',
    description: 'Product Import Modal Title',
  },
  productImportModalBody: {
    defaultMessage:
      "If you'd like to import product information from a spreadsheet or other datasource, you can provide your data in our standard CSV file format. As products are imported we will create products that do not already exist and optionally update existing products.",
    id: 'TIeK+E',
    description: 'Product Import Modal Body',
  },
  productBundlesImportModalTitle: {
    defaultMessage: 'Product Bundles Import',
    id: 's58xZs',
    description: 'Product Bundles Import Modal Title',
  },
  productBundlesImportModalBody: {
    defaultMessage:
      'Upload your product bundle configurations using a CSV file in the format specified in the example below.{br}For each row:',
    id: '2/2cGz',
    description: 'Product Import Modal Body',
  },
  productBundlesImportModalBodyList: {
    defaultMessage:
      "<li>If a bundle doesn't exist, we'll create it with its components.</li>" +
      "<li>If the bundle already exists, we'll add the new components or update their quantities as needed.</li>",
    id: 'YN6OT1',
    description: 'Product Import Modal Body',
  },
  productImportSelectOptions: {
    defaultMessage: '2. Select Options',
    id: '/M80Te',
    description: 'Product Import Select Options Title',
  },
  productImportIdentifyProductDesc: {
    defaultMessage:
      'As products are imported, we will attempt to identify whether they already exist. You can select which field uniquely identifies a product.',
    id: 'V3Vhfi',
    description: 'Product Import Option One Description',
  },
  productImportCreateorUpdateProductDesc: {
    defaultMessage: 'You can choose to update products if they already exist or to only import new products.',
    id: 'jFA19M',
    description: 'Product Import Option Two Description',
  },
  productAliasImportModalTitle: {
    defaultMessage: 'Product Alias Import',
    id: 'fJpe2r',
    description: 'Product Alias Import Modal Title',
  },
  productAliasImportModalBody: {
    defaultMessage:
      "If you'd like to import product alias information from a spreadsheet or other datasource, you can provide your data in our standard CSV file format. For more information about importing product aliases, <a>click here.</a>",
    id: 'tmh8Tw',
    description: 'Product Alias Import Modal Body',
  },
  productImportDownloadSampleCSV: {
    defaultMessage: 'Download a sample CSV file',
    id: 'aS0mw7',
    description: 'Product Import Download Sample CSV Link Text',
  },
  productImportSelectFileToImport: {
    defaultMessage: '1. Select a File to Import',
    id: 'jenKDT',
    description: 'Product Import Select File to Import',
  },
  productImportIDBySku: {
    defaultMessage: 'Identify products uniquely by <b>SKU</b>',
    id: 'aXrKMh',
    description: 'Product Import Modal Identify By SKU Option',
  },
  productImportIDByName: {
    defaultMessage: 'Identify products uniquely by <b>Name</b>',
    id: 'zvkiIK',
    description: 'Product Import Modal Identify By Name Option',
  },
  productImportUpdateAllOption: {
    defaultMessage: 'Update product information if the products already exist',
    id: 'OhB91v',
    description: 'Product Import Modal Update All Option',
  },
  productImportUpdateNewOption: {
    defaultMessage: 'Ignore any products that already exist (only new products will be imported)',
    id: 'qM1Wqk',
    description: 'Product Import Modal Update New Option',
  },
  productImportModalStarted: {
    defaultMessage:
      'Your product import has started. This may take a while so feel free to close this window. We will let you know when the import is complete.',
    id: 'vKb3lp',
    description: 'Product Import Modal Started',
  },
  productExportModalTitle: {
    defaultMessage: 'Product Export',
    id: '/e2m4R',
    description: 'Product Export Modal Title',
  },
  productExportModalStarted: {
    defaultMessage:
      'Your product export has started. This may take a while so feel free to close this window. We will let you know when the export is complete.',
    id: 'moPkHI',
    description: 'Product Export Modal Started',
  },
  productExportWhich: {
    defaultMessage: 'Which records would you like to export?',
    id: 'y/+X2c',
    description: 'Product Export Which',
  },
  productExportSelectedItems: {
    defaultMessage: 'Only export the { selectedProductCount } record(s) that are currently selected',
    id: 'Q2ioyq',
    description: 'Product Export Selected Items',
  },
  productExportAllItems: {
    defaultMessage: 'Export ALL { productCount } record(s) that are in view',
    id: '0lrxeS',
    description: 'Product Export Selected Items',
  },
  productDeactivateModalTitle: {
    defaultMessage: 'Deactivate Product(s)',
    id: 'FuuVlt',
    description: 'Product Deactivate Modal Title',
  },
  productDeactivateModalBody: {
    defaultMessage: 'Are you sure you want to deactivate the selected products?',
    id: 'NcoRBt',
    description: 'Product Deactivate Modal Body',
  },
  exportButton: {
    defaultMessage: 'Export',
    id: 'YlLRHM',
    description: 'Product Export Modal button',
  },
  importButton: {
    defaultMessage: 'Import',
    id: 'kwNFxH',
    description: 'Product Import Modal button',
  },
  importModalCSVError: {
    description: 'Import Modal File Upload Error',
    defaultMessage: 'Please select a valid .CSV file',
    id: 'y9lxoH',
  },
  defaultSelectFileButtonMessage: {
    description: 'Import Modal File Select File Button',
    defaultMessage: 'Select File',
    id: 'JSXJph',
  },
});
